import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import LiveOps from './pages/LiveOps.jsx';
import TodaysTrips from './pages/TodaysTrips.jsx';
import TripDetail from './pages/TripDetail.jsx';
import CentralizedRequests from './pages/CentralizedRequests.jsx';
import TrsVerdicts from './pages/TrsVerdicts.jsx';
import Anomalies from './pages/Anomalies.jsx';
// Batches pulls in Recharts (~120KB gzipped) — lazy-load so it only enters
// the bundle when an operator visits /batches.
const Batches = lazy(() => import('./pages/Batches.jsx'));
import Config from './pages/Config.jsx';
import Login from './pages/Login.jsx';
import { useMe } from './lib/api';

function RequireAuth({ children }) {
  const { data, isLoading, isError } = useMe();
  const loc = useLocation();

  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center text-slate-500">Checking session…</div>;
  }
  if (isError || !data?.user) {
    const next = loc.pathname + loc.search;
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />;
  }
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<RequireAuth><Layout /></RequireAuth>}>
        <Route path="/"                  element={<LiveOps />} />
        <Route path="/trips"             element={<TodaysTrips />} />
        <Route path="/trips/:tripId"     element={<TripDetail />} />
        <Route path="/centralized-requests" element={<CentralizedRequests />} />
        <Route path="/trs"               element={<TrsVerdicts />} />
        <Route path="/anomalies"         element={<Anomalies />} />
        <Route path="/batches"           element={
          <Suspense fallback={<div className="text-slate-500">Loading batch charts…</div>}>
            <Batches />
          </Suspense>
        } />
        <Route path="/config"            element={<Config />} />
        <Route path="*"                  element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
